import { isRight } from 'fp-ts/lib/Either';
import { UTMParams } from './types';
const decodeUTMParamsData = (input) => {
    try {
        const object = JSON.parse(input);
        const cookieConsentsDecodeResult = UTMParams.decode(object);
        if (isRight(cookieConsentsDecodeResult)) {
            return cookieConsentsDecodeResult.right;
        }
        return undefined;
    }
    catch (_a) {
        return undefined;
    }
};
export { decodeUTMParamsData };
